<template>
  <div class="container">
    <div class="tab-list">
      <div
        @click="goList"
        class="category-box"
        @mouseenter="showToSecondMenu"
        @mouseleave="hideToSecondMenu"
      >
        <!-- <div
          class="menu-text"
          v-if="hideSecondMenu"
          
        >
          全部药品分类
        </div> -->
        <div class="menu-text">全部药品分类</div>
        <!-- 二级菜单 -->
        <div
          class="menu-list"
          v-if="!hideSecondMenuTip && mainCategoryList.length > 0"
        >
          <ul class="ul-box" @mouseleave="hideMenu" ref="ulBox">
            <li
              v-for="(item, index) of mainCategoryList"
              :key="item.id"
              @mouseenter="enterMenu(index)"
              :class="active === index ? 'active' : ''"
              @click.stop=""
            >
              <div class="img">
                <img :src="item.pc_pic" alt="" />
                <img :src="item.pc_pic2" alt="" v-if="active === index" />
              </div>
              {{ item.cate_name }}
              <!-- 第三级菜单 -->
              <div class="third-list" v-if="active === index">
                <div class="title">{{ item.cate_name }}</div>
                <div class="tip-list">
                  <div
                    v-for="val of thirdList"
                    :key="val.id"
                    @click.stop="thirdCategory(item.id, val.id)"
                    class="tip"
                  >
                    {{ val.cate_name }}
                  </div>
                </div>
              </div>
            </li>
            <li
              @mouseenter="enterMenu(11)"
              :class="active === 11 ? 'active' : ''"
              @click.stop=""
            >
              <div class="img-add">
                <Icon type="plus-round" class="add"></Icon>
              </div>
              更多科室
              <!-- 第三级菜单 -->
              <div class="third-list more-menu" v-if="active === 11">
                <div
                  class="more-list"
                  v-for="item of mainCategoryMore"
                  :key="item.id"
                >
                  <div class="title">{{ item.cate_name }}</div>
                  <div class="tip-list">
                    <div
                      v-for="val of item.children"
                      :key="val.id"
                      @click.stop="thirdCategory(item.id, val.id)"
                      class="tip"
                    >
                      {{ val.cate_name }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="other-menu-list">
        
        <CommonTabMenu></CommonTabMenu>
      </div>
      <div class="commany" v-if="!hideSecondMenu">
        <div class="commany-title">元芝庄药业有限公司</div>
        <div class="commany-des">
          Yuanzhizhuang Pharmaceutical Comércio Limitada
        </div>
        <div class="commany-code">
          <div class="img">
            <img src="@assets/pc/images/home/weixin.png" alt="" />
          </div>
          <div class="tip">微信二维码</div>
        </div>
        <div class="commany-whatscode">
          <div class="img">
            <img src="@assets/pc/images/home/whatsapp.png" alt="" />
          </div>
          <div class="tip">WhatsApp二维码</div>
        </div>
        <div class="commany-promise">
          <!-- <img src="@assets/pc/images/index/promise.png" alt="" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonTabMenu from "@components/pc/nav/CommonTabMenu";
import { getCategory } from "@api/public";
export default {
  name: "TabBar",
  components: {
    CommonTabMenu
  },
  props: {
    topic: {
      type: Array
    },
    // 二级菜单栏是否显示
    hideSecondMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mainCategory: [],
      menuMask: false,
      active: "",
      thirdList: [],
      hideSecondMenuTip: false
    };
  },
  computed: {
    mainCategoryList() {
      return this.mainCategory.filter((item, index) => {
        if (index < 10) return true;
      });
    },
    mainCategoryMore() {
      return this.mainCategory.filter((item, index) => {
        if (index > 10) return true;
      });
    }
  },
  watch: {
    hideSecondMenu: {
      immediate: true,
      handler() {
        if (this.hideSecondMenu) {
          this.hideSecondMenuTip = true;
        }
      }
    }
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    goList() {
      this.$router.push({
        path: "/goodsCategory"
      });
    },
    getCategoryList() {
      getCategory().then(res => {
        this.mainCategory = res.data;
      });
    },
    showMenu() {
      this.menuMask = true;
    },
    hideMenu() {
      this.$refs.ulBox.style.width = "200px";
      this.menuMask = false;
      this.active = "";
    },
    enterMenu(index) {
      this.menuMask = true;
      this.$refs.ulBox.style.width = "800px";
      this.active = index;
      this.thirdList = this.mainCategory[index].children;
    },
    thirdCategory(mainId, secondId) {
      this.$router.push({
        name: "GoodsList",
        params: {
          mainId: mainId,
          secondId: secondId
        }
      });
    },
    showToSecondMenu() {
      if (this.hideSecondMenu) {
        this.hideSecondMenuTip = false;
      }
    },
    hideToSecondMenu() {
      if (this.hideSecondMenu) {
        this.hideSecondMenuTip = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
div.container
  background #fff
  border-bottom 2px solid #3284dd
  min-width 1200px
  .tab-list
    width 1200px
    margin 0 auto
    display flex
    height 40px
    line-height 40px
    font-size 16px
    position relative
    .category-box
      position relative
      width 200px
      background #1880f4
      color #fff
      font-size 16px
      font-weight 400
      border-right 0
      text-align center
      cursor pointer
      .menu-list
        position absolute
        z-index: 100;
        width 200px
        background #1880f4
        color #fff
        font-size 16px
        text-align left
        .ul-box
          height 450px
          li
            font-size 15px
            line-height 40px
            font-weight normal
            padding-left 16px
            border-bottom 1px solid rgba(255, 255, 255, 0.3)
            &:last-child
              border-bottom 2px solid #1880f4
            &.active
              background #fff
              color #1880f4
              &:first-child
                transform translateY(2px)
              &::before
                content ''
                position absolute
                left 0
                width 1px
                height 42px
                background #1880f4
            .img
              display inline-block
              width 20px
              height 20px
              transform translateY(5px)
              margin-right 5px
              position relative
              img
                position absolute
                width 100%
                height 100%
            .img-add
              display inline-block
              transform translateX(1px) translateY(2px)
              margin-right 2px
              .add
                color #86b8e9
                font-size 22px
          .third-list
            position absolute
            background #fff
            top 2px
            left 200px
            width 600px
            height 450px
            padding 15px 30px
            border-right 1px solid #1880f4
            border-bottom 2px solid #1880f4
            overflow-y auto
            &::-webkit-scrollbar
              width 7px
            &::-webkit-scrollbar-thumb
              background #607d8b
              -webkit-border-radius: 10px;
              -moz-border-radius: 10px;
              border-radius: 10px;
            .title
              font-size 14px
              color #333
              font-weight 550
              line-height 28px
              cursor auto
            .tip-list
              display flex
              flex-wrap wrap
              line-height 24px
              .tip
                font-size 14px
                color #0000FF
                width 25%
                height 48px
                cursor pointer
                &:hover
                  color red
            .more-list
              margin-bottom 15px
          .more-menu
            width 800px

    .commany
      position absolute
      width 200px
      height 450px
      background #fff
      z-index 100
      right 0
      top 42px
      text-align center
      &-title
        font-weight 550
        font-size 15px
        margin-top 30px
      &-des
        color #999
        font-size 10px
        line-height 12px
        padding-bottom 20px
        border-bottom 1px solid #ddd
      &-code
        margin-top 30px
        font-size 15px
        color #999
        line-height 34px
        .img
          margin 0 auto
          width 100px
          height 100px
          img
            width 100%
            height 100%
        .tip
          margin-top 5px
          margin-bottom 30px
      &-whatscode
        margin-top 30px
        font-size 15px
        color #999
        line-height 34px
        .img
          margin 0 auto
          width 95px
          height 95px
          img
            width 95%
            height 95%
        .tip
          margin-top 5px
          margin-bottom 30px
      &-promise
        border-top 1px dashed #ccc
        padding-top 20px
        margin 0 20px
        img
          width 100%
          height 100%
</style>
